<template>
  <div class="news-base " v-if="HomeNews">
    <rl-title :show-name="HomeNews.name"/>
    <div class="news-content">
      <home-news-item
          v-for="(item,index) in HomeNews.photoList " :key="index"
          :news-item="item"
      ></home-news-item>
    </div>
    <ripeav-more url-link="/news" ripeav-more="查看更多" style="margin:  0 auto;text-align: center;"></ripeav-more>
  </div>
</template>

<script>
import HomeNewsItem from "@/views/Home/HomeNews/HomeNewsItem";

import RipeavMore from "../../../components/RipeavMore";
import RlTitle from "@/components/Title";
export default {
  name: "HomeNews",
  components: {RlTitle, RipeavMore, HomeNewsItem},
  props:{
    HomeNews:{
    },
    data(){
      return{
        list:[]
      }
    },
  },
  created() {
    console.log(this.props)
    // this.list = this.props.photoList.reverse()
    console.log(this.list)
  }

}
</script>

<style lang="less" scoped>
  .news-base{
    width: 74.5vw;
    margin:0 auto;
    min-height: 685px;
    padding-bottom: 20px;
    position: relative;
    .news-title{
      text-align: center;
      margin: 30px 0 60px 0;
      span{
        width: 231px;
        height: 32px;
        font-size: 32px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        letter-spacing: 1px;
      }
    }
    .news-content{
      display: flex;
      justify-content: space-between;
      margin-bottom: 60px;
    }
  }
</style>